// import { useState, useEffect } from "react";
// import Typography from "@mui/material/Typography";
// import CircularProgress from '@mui/material/CircularProgress';
// import axiosClient from "../axiosClient";
// import * as XLSX from "xlsx";
// import {
//   Box,
//   Button,
//   CardContent,
//   Table,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
//   Grid,
// } from "@mui/material";
// import { Card, Paper, TableBody } from "@mui/material";
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs from 'dayjs';
// import isoWeek from 'dayjs/plugin/isoWeek';

// dayjs.extend(isoWeek);

// function SendEmailSMS() {
//   const [message, setMessage] = useState("Loading Excel data...");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [excelData, setExcelData] = useState([]);
//   const [periodType, setPeriodType] = useState('month');
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [recipientEmail, setRecipientEmail] = useState('');
//   const [reportMessage, setReportMessage] = useState('');
//   const [emailError, setEmailError] = useState('');

//   useEffect(() => {
//     displayData();
//   }, []);

//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const handleEmailChange = (e) => {
//     const email = e.target.value;
//     setRecipientEmail(email);
//     if (email && !validateEmail(email)) {
//       setEmailError('Please enter a valid email address');
//     } else {
//       setEmailError('');
//     }
//   };

//   const clearForm = () => {
//     setPeriodType('month');
//     setSelectedDate(dayjs());
//     setRecipientEmail('');
//     setEmailError('');
//     setReportMessage('');
//   };

//   const downloadExcel = () => {
//     setLoading(true);
//     setMessage("Downloading file...");

//     axiosClient
//       .get("api/excel_document_of_email_sms/", { responseType: "blob" })
//       .then((response) => {
//         const file = new Blob([response.data]);

//         // Trigger file download
//         const url = window.URL.createObjectURL(file);
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", "email_sms.xlsx");
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link); // Clean up after download

//         setLoading(false);
//         setMessage("File downloaded successfully!");
//       })
//       .catch((err) => {
//         setError("Failed to download file.");
//         setLoading(false);
//       });
//   };

//   const displayData = () => {
//     setLoading(true);
//     setMessage("Loading data...");

//     axiosClient
//       .get("api/excel_document_of_email_sms/", { responseType: "blob" })
//       .then((response) => {
//         const file = new Blob([response.data]);
//         const reader = new FileReader();

//         // Read the file for displaying its contents
//         reader.onload = (e) => {
//           const data = new Uint8Array(e.target.result);
//           const workbook = XLSX.read(data, { type: "array" });

//           // Parse data from the first sheet
//           const worksheet = workbook.Sheets[workbook.SheetNames[0]];
//           const jsonData = XLSX.utils.sheet_to_json(worksheet);

//           setExcelData(jsonData);
//           setLoading(false);
//           setMessage("Data loaded successfully!");
//         };

//         reader.onerror = () => {
//           setError("Error reading the Excel file.");
//           setLoading(false);
//         };

//         reader.readAsArrayBuffer(file); // Trigger reading of the file
//       })
//       .catch((err) => {
//         setError("Failed to load data.");
//         setLoading(false);
//       });
//   };

//   const handleSendReport = () => {
//     if (!validateEmail(recipientEmail)) {
//       setEmailError('Please enter a valid email address');
//       return;
//     }

//     setLoading(true);
//     setReportMessage('');

//     let periodValue;
//     if (periodType === 'month') {
//       periodValue = selectedDate.format('YYYY-MM');
//     } else {
//       periodValue = `${selectedDate.format('YYYY')}-W${selectedDate.isoWeek()}`;
//     }

//     axiosClient
//       .post("/api/sms-report/", {
//         period_type: periodType,
//         period_value: periodValue,
//         email: recipientEmail
//       })
//       .then((response) => {
//         setReportMessage(response.data.message);
//         setLoading(false);
//       })
//       .catch((err) => {
//         setReportMessage(err.response?.data?.error || 'Failed to send report');
//         setLoading(false);
//       });
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h6" align="center" gutterBottom>
//           Send SMS Report
//         </Typography>

//         <Grid container spacing={2} sx={{ mb: 3 }}>
//           {/* Form Controls */}
//           <Grid item xs={12} sm={4}>
//             <FormControl fullWidth>
//               <InputLabel>Period Type</InputLabel>
//               <Select
//                 value={periodType}
//                 onChange={(e) => setPeriodType(e.target.value)}
//                 label="Period Type"
//               >
//                 <MenuItem value="month">Month</MenuItem>
//                 <MenuItem value="week">Week</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <DatePicker
//               label={periodType === 'month' ? 'Select Month' : 'Select Week'}
//               views={periodType === 'month' ? ['year', 'month'] : ['year', 'month', 'day']}
//               value={selectedDate}
//               onChange={(newValue) => setSelectedDate(newValue)}
//               slotProps={{ textField: { fullWidth: true } }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4}>
//             <TextField
//               fullWidth
//               label="Recipient Email"
//               value={recipientEmail}
//               onChange={handleEmailChange}
//               type="email"
//               error={!!emailError}
//               helperText={emailError}
//             />
//           </Grid>

//           {/* Action Buttons */}
//           <Grid item xs={12}>
//             <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'center' }}>
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 onClick={handleSendReport}
//                 disabled={loading || !recipientEmail || !!emailError}
//               >
//                 Send SMS Report
//               </Button>
//               <Button
//                 variant="outlined"
//                 color="primary"
//                 onClick={clearForm}
//                 disabled={loading}
//               >
//                 Clear
//               </Button>
//             </Box>
//           </Grid>

//           {/* Status Messages and Loading Indicator */}
//           <Grid item xs={12}>
//             <Box sx={{ textAlign: 'center', mt: 2 }}>
//               {loading && <CircularProgress sx={{ mb: 2 }} />}
//               {reportMessage && (
//                 <Typography
//                   variant="body1"
//                   color={reportMessage.includes('successfully') ? 'success.main' : 'error.main'}
//                 >
//                   {reportMessage}
//                 </Typography>
//               )}
//             </Box>
//           </Grid>
//         </Grid>

//         {/* Excel Data and Download Button */}
//         <Card elevation={16}>
//           <CardContent>
//             <Box sx={{ mb: 2, textAlign: 'center' }}>
//               {loading ? (
//                 <Typography variant="h6" color="text.primary">
//                   Loading data...
//                 </Typography>
//               ) : error ? (
//                 <Typography variant="h6" color="error.main">
//                   {error}
//                 </Typography>
//               ) : (
//                 <Typography variant="h6" color="text.primary">
//                   {message}
//                 </Typography>
//               )}
//             </Box>
//             <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={downloadExcel}
//                 disabled={loading}
//               >
//                 Download Excel File
//               </Button>
//             </Box>
//             {!loading && !error && excelData.length > 0 && (
//               <TableContainer component={Paper} style={{ maxHeight: 800 }}>
//                 <Typography variant="h6" gutterBottom>
//                   Excel Data:
//                 </Typography>
//                 <Table>
//                   <TableHead>
//                     <TableRow>
//                       {excelData.length > 0 &&
//                         Object.keys(excelData[0]).map((key) => (
//                           <TableCell key={key}>{key}</TableCell>
//                         ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {excelData.map((row, index) => (
//                       <TableRow key={index}>
//                         {Object.values(row).map((val, i) => (
//                           <TableCell key={i}>{val}</TableCell>
//                         ))}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;



import { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import axiosClient from "../axiosClient";
import * as XLSX from "xlsx";
import {
  Box,
  Button,
  CardContent,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
} from "@mui/material";
import { Card, Paper, TableBody } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { useTranslation } from "react-i18next";

dayjs.extend(isoWeek);

function SendEmailSMS() {
  const { t } = useTranslation();

  // αποθηκεύουμε KEYS και όχι έτοιμα κείμενα
  const [messageKey, setMessageKey] = useState("excel.loadingExcelData");
  const [loading, setLoading] = useState(true);
  const [errorKey, setErrorKey] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [periodType, setPeriodType] = useState("month");
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [recipientEmail, setRecipientEmail] = useState("");
  const [reportMessage, setReportMessage] = useState("");
  const [emailErrorKey, setEmailErrorKey] = useState("");

  useEffect(() => {
    displayData();
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setRecipientEmail(email);
    if (email && !validateEmail(email)) {
      setEmailErrorKey("validation.validEmail");
    } else {
      setEmailErrorKey("");
    }
  };

  const clearForm = () => {
    setPeriodType("month");
    setSelectedDate(dayjs());
    setRecipientEmail("");
    setEmailErrorKey("");
    setReportMessage("");
  };

  const downloadExcel = () => {
    setLoading(true);
    setMessageKey("excel.downloadingFile");
    setErrorKey(null);

    axiosClient
      .get("api/excel_document_of_email_sms/", { responseType: "blob" })
      .then((response) => {
        const file = new Blob([response.data]);

        // Trigger file download
        const url = window.URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "email_sms.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setLoading(false);
        setMessageKey("excel.fileDownloadedSuccessfully");
      })
      .catch(() => {
        setErrorKey("excel.failedToDownloadFile");
        setLoading(false);
      });
  };

  const displayData = () => {
    setLoading(true);
    setMessageKey("excel.loadingData");
    setErrorKey(null);

    axiosClient
      .get("api/excel_document_of_email_sms/", { responseType: "blob" })
      .then((response) => {
        const file = new Blob([response.data]);
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          setExcelData(jsonData);
          setLoading(false);
          setMessageKey("excel.dataLoadedSuccessfully");
        };

        reader.onerror = () => {
          setErrorKey("excel.errorReadingFile");
          setLoading(false);
        };

        reader.readAsArrayBuffer(file);
      })
      .catch(() => {
        setErrorKey("excel.failedToLoadData");
        setLoading(false);
      });
  };

  const handleSendReport = () => {
    if (!validateEmail(recipientEmail)) {
      setEmailErrorKey("validation.validEmail");
      return;
    }

    setLoading(true);
    setReportMessage("");

    let periodValue;
    if (periodType === "month") {
      periodValue = selectedDate.format("YYYY-MM");
    } else {
      periodValue = `${selectedDate.format("YYYY")}-W${selectedDate.isoWeek()}`;
    }

    axiosClient
      .post("/api/sms-report/", {
        period_type: periodType,
        period_value: periodValue,
        email: recipientEmail,
      })
      .then((response) => {
        setReportMessage(response.data.message);
        setLoading(false);
      })
      .catch((err) => {
        setReportMessage(
          err.response?.data?.error || t("smsReport.failedToSendReport")
        );
        setLoading(false);
      });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: 3 }}>
        {/* ΤΙΤΛΟΣ ΣΕΛΙΔΑΣ */}
        <Typography variant="h6" align="center" gutterBottom>
          {t("smsReport.title")}
        </Typography>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          {/* Period Type */}
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>{t("smsReport.periodType")}</InputLabel>
              <Select
                value={periodType}
                onChange={(e) => setPeriodType(e.target.value)}
                label={t("smsReport.periodType")}
              >
                <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
                <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Date picker */}
          <Grid item xs={12} sm={4}>
            <DatePicker
              label={
                periodType === "month"
                  ? t("smsReport.selectMonth")
                  : t("smsReport.selectWeek")
              }
              views={
                periodType === "month"
                  ? ["year", "month"]
                  : ["year", "month", "day"]
              }
              value={selectedDate}
              onChange={(newValue) => setSelectedDate(newValue)}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </Grid>

          {/* Recipient email */}
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label={t("smsReport.recipientEmail")}
              value={recipientEmail}
              onChange={handleEmailChange}
              type="email"
              error={!!emailErrorKey}
              helperText={emailErrorKey ? t(emailErrorKey) : ""}
            />
          </Grid>

          {/* Buttons */}
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                onClick={handleSendReport}
                disabled={loading || !recipientEmail || !!emailErrorKey}
              >
                {t("smsReport.sendButton")}
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={clearForm}
                disabled={loading}
              >
                {t("common.clear")}
              </Button>
            </Box>
          </Grid>

          {/* Status Messages */}
          <Grid item xs={12}>
            <Box sx={{ textAlign: "center", mt: 2 }}>
              {loading && <CircularProgress sx={{ mb: 2 }} />}
              {reportMessage && (
                <Typography
                  variant="body1"
                  color={
                    reportMessage.includes("success")
                      ? "success.main"
                      : "error.main"
                  }
                >
                  {reportMessage}
                </Typography>
              )}
            </Box>
          </Grid>
        </Grid>

        {/* Excel block */}
        <Card elevation={16}>
          <CardContent>
            <Box sx={{ mb: 2, textAlign: "center" }}>
              {loading ? (
                <Typography variant="h6" color="text.primary">
                  {t("excel.loadingData")}
                </Typography>
              ) : errorKey ? (
                <Typography variant="h6" color="error.main">
                  {t(errorKey)}
                </Typography>
              ) : (
                <Typography variant="h6" color="text.primary">
                  {t(messageKey)}
                </Typography>
              )}
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={downloadExcel}
                disabled={loading}
              >
                {t("excel.downloadButton")}
              </Button>
            </Box>

            {!loading && !errorKey && excelData.length > 0 && (
              <TableContainer component={Paper} style={{ maxHeight: 800 }}>
                <Typography variant="h6" gutterBottom>
                  {t("excel.excelDataHeader")}
                </Typography>
                <Table>
                  <TableHead>
                    <TableRow>
                      {excelData.length > 0 &&
                        Object.keys(excelData[0]).map((key) => (
                          <TableCell key={key}>{key}</TableCell>
                        ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {excelData.map((row, index) => (
                      <TableRow key={index}>
                        {Object.values(row).map((val, i) => (
                          <TableCell key={i}>{val}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </CardContent>
        </Card>
      </Box>
    </LocalizationProvider>
  );
}

export default SendEmailSMS;

